import React, { useEffect, useState } from "react";
import {
  Drawer,
  Box,
  Typography,
  Chip,
  Divider,
  Tooltip,
  Button,
  Popover,
  TextField,
  InputAdornment,
  Tabs,
  Tab,
  Skeleton,
  CircularProgress,
} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import AssetsFlyout from "./Assets-Flyout";
import Compliance from "./Compliance-flyout";
import DetailsFlyout from "./Details-Flyout";
import Logoutput from "./Logoutput";
import Pencil_Blue from "../../assets/baseVersion/Pencil_Blue.svg";
import Pencil_Light_img from "../../assets/baseVersion/Pencil_Light_img.svg";
import Plus_Blue_img from "../../assets/baseVersion/Plus_Blue_img.svg";
import SearchIcon from "@mui/icons-material/Search";
import axiosInstance from "../../axios/axios";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useDispatch } from "react-redux";
import { setTabSelected } from "./TabSelection-slice";
import LogoutputManual from "./LogoutputManual";

interface SecurityDetailsDrawerProps {
  open: boolean;
  onClose: () => void;
  row: any;
  module: string;
  formik?: any;
  selectedRow?: any;
  fetchData?: any;
  showBackButton?: boolean;
}

interface CreateTag {
  default?: string[];
  user?: string[];
}

const SecurityDetailsDrawer: React.FC<SecurityDetailsDrawerProps> = ({
  open,
  onClose,
  row,
  module,
  selectedRow,
  fetchData,
  showBackButton,
}) => {

  const [headerResponse, setHeaderResponse] = useState<any>(null);
  // const [isCreateTag, setIsCreateTag] = useState<{
  //   default?: string[];
  //   user?: string[];
  // }>({});
  const [totalResources, setTotalResources] = useState<any>(null);
  const [showLogOutput, setShowLogOutput] = useState(false);
  const [logOutputRowData, setLogOutputRowData] = useState<any>(null);
  const [isCreateTagClicked, setIsCreateTagClicked] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [assetsData, setAssetsData] = useState<any[]>([]);
  // Debug: Assets data for navigation
  console.log("Assets for navigation:", assetsData.length, "assets");

  const [isHovered, setIsHovered] = useState(false);
  const [value, setValue] = useState(0);
  const [isCreateTag, setIsCreateTags] = useState<CreateTag>({});
  const [isLoading, setIsLoading] = useState(false);
  const [isCreatingTag, setIsCreatingTag] = useState(false);
  const dispatch = useDispatch();

  const handleClose = () => {
    onClose();
    setShowLogOutput(false);
    setIsCreateTagClicked(false);
    setAnchorEl(null);
    setValue(0);
    dispatch(setTabSelected(0));
  };

  const handleNextAsset = () => {
    // Filter assets to only include Juniper devices
    const juniperAssets = assetsData.filter(asset => asset.vendor === "juniper");
    const currentJuniperIndex = juniperAssets.findIndex(asset => asset.id === logOutputRowData?.id);

    console.log("Next: Current index", currentJuniperIndex, "of", juniperAssets.length - 1);

    if (juniperAssets.length > 0 && currentJuniperIndex < juniperAssets.length - 1) {
      const nextJuniperAsset = juniperAssets[currentJuniperIndex + 1];
      console.log("Moving to:", nextJuniperAsset.hostname);
      setLogOutputRowData(nextJuniperAsset);
    }
  };

  const handlePreviousAsset = () => {
    // Filter assets to only include Juniper devices
    const juniperAssets = assetsData.filter(asset => asset.vendor === "juniper");
    const currentJuniperIndex = juniperAssets.findIndex(asset => asset.id === logOutputRowData?.id);

    console.log("Previous: Current index", currentJuniperIndex, "of", juniperAssets.length - 1);

    if (juniperAssets.length > 0 && currentJuniperIndex > 0) {
      const prevJuniperAsset = juniperAssets[currentJuniperIndex - 1];
      console.log("Moving to:", prevJuniperAsset.hostname);
      setLogOutputRowData(prevJuniperAsset);
    }
  };

  useEffect(() => {
    if (!row) return;
    setValue(0);
    dispatch(setTabSelected(0));
    setShowLogOutput(false);
    setIsLoading(true);
    // Fetch header details
    axiosInstance
      .get(`securityscan/control-details/${row.id}`)
      .then((response) => {
        setHeaderResponse(response.data?.data);
        setIsCreateTags(response.data?.data?.tags);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching details:", error);
        setIsLoading(false);
      });

    // Fetch total resources
    axiosInstance
      .get(`securityscan/control-asset-details/${row.id}?module=${module}`)
      .then((response) => setTotalResources(response.data?.data))
      .catch((error) =>
        console.error("Error fetching total resources:", error)
      );
  }, [row, module]);

  const fetchControlDetails = (showLoader = true) => {
    if (selectedRow) {
      if (showLoader) setIsLoading(true);
      axiosInstance
        .get(`securityscan/control-details/${selectedRow.id}`)
        .then((response) => {
          setHeaderResponse(response.data?.data);
          setIsCreateTags(response.data?.data?.tags);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching details:", error);
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    fetchControlDetails();
  }, [selectedRow]);

  const formik = useFormik({
    initialValues: {
      create_tag: "",
    },
    onSubmit: async (values) => {
      try {
        setIsCreatingTag(true);
        const response = await axiosInstance.post("securityscan/create-tag", {
          tag_name: values.create_tag,
          parent_id: null,
          parameter_name_id: selectedRow.id,
        });
        console.log(response.data, "response.data");
        toast(response?.data?.message, { type: "success" });
        formik.resetForm();
        setIsCreateTagClicked(false);
        await fetchControlDetails(false);
        if (fetchData) {
          await fetchData();
        }
      } catch (error) {
        console.log(error, "error");
        // toast((error as any)?.response?.data?.message || "Something went wrong", {
        //   type: "error",
        // });
      } finally {
        setIsCreatingTag(false);
      }
    },
  });
  // Show user-created tags first so newly created tags appear at the top
  const allTags = [
    ...(isCreateTag?.user || []),
    ...(isCreateTag?.default || []),
  ];
  const visibleTags = allTags.slice(0, 3);
  const hiddenTags = allTags.slice(3);

  const getStyledTag = (tag: string, index: number) => {
    const styles = [
      { color: "#018319", backgroundColor: "#0183191A" }, // green
      { color: "#894B00", backgroundColor: "#894B001A" }, // brown
      { color: "#0485C2", backgroundColor: "#0485C21A" },
      { color: "#3A2ADA", backgroundColor: "#1103C014" }, // blue
      { color: "gray", backgroundColor: "#E0E0E0" }, // gray
    ];

    const style = styles[index] || {
      color: "black",
      backgroundColor: "#f0f0f0",
    };

    // Ellipsis logic: if tag length > 15, show first 5 chars + ...
    let displayTag = tag;
    if (tag.length > 15) {
      displayTag = tag.slice(0, 10) + "...";
    }

    return (
      <Chip
        key={index}
        label={displayTag}
        style={style}
        sx={{ borderRadius: 1, fontWeight: "bold" }}
        size="small"
      />
    );
  };

  const getImage = () => (isHovered ? Pencil_Blue : Pencil_Light_img);

  const handleClick = (event: React.MouseEvent<HTMLElement>) =>
    setAnchorEl(event.currentTarget);
  const handleClosePopover = () => {
    setAnchorEl(null);
    setIsCreateTagClicked(false);
  };
  const openPopover = Boolean(anchorEl);
  const id = openPopover ? "simple-popover" : undefined;

  const getSeverityStyle = (severity: string) => {
    switch (severity?.toLowerCase()) {
      case "low":
        return { color: "#F2BF00", backgroundColor: "#F2BF0024" };
      case "high":
        return { color: "#A7000F", backgroundColor: "#A7000F24" };
      case "critical":
        return { color: "#670004", backgroundColor: "#67000424" };
      case "medium":
        return { color: "#E85800", backgroundColor: "#E8580024" };
      default:
        return { color: "gray", backgroundColor: "#E0E0E0" };
    }
  };
  const Chipstyle = getSeverityStyle(headerResponse?.severity);

  const TypeChipColor = (type: string) => {
    switch (type) {
      case "Manual":
        return { color: "#2B335F", bgcolor: "#DEDDF2" };
      case "Automated":
        return { color: "#0B3D2E", bgcolor: "#CFF3E0" };
      default:
        return { color: "#000", bgcolor: "#E0E0E0" };
    }
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          width: "50%",
          bgcolor: "background.paper",
        },
      }}
    >
      <Box
        sx={{
          padding: 2,
          borderBottom: 1,
          borderColor: "divider",
          position: "sticky",
          top: 0,
          zIndex: 10,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginBottom: 3,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {/* {showBackButton && (
              <HighlightOffIcon
              sx={{ color: "#3A2ADA", cursor: "pointer", mr: 1 }}
              onClick={onClose}
              /> */}
            {showBackButton && (
              <ArrowBackIcon
                sx={{ cursor: "pointer", mr: 1 }}
                onClick={handleClose}
              />
            )}
            {isLoading ? (
              <Skeleton variant="text" width={200} height={32} />
            ) : (
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                {headerResponse?.normalized_name}
              </Typography>
            )}
          </Box>
          <HighlightOffIcon
            sx={{ color: "#A6A5B6", cursor: "pointer", mt: 0.6 }}
            onClick={handleClose}
          />
        </div>

        {isLoading ? (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 5,
              marginBottom: 3,
              alignItems: "center",
            }}
          >
            <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 1 }} />
            <Skeleton variant="rectangular" width={100} height={24} sx={{ borderRadius: 1 }} />
            <Divider orientation="vertical" flexItem />
            <Skeleton variant="text" width={40} height={20} />
            <Skeleton variant="rectangular" width={60} height={24} sx={{ borderRadius: 1 }} />
            <Skeleton variant="rectangular" width={60} height={24} sx={{ borderRadius: 1 }} />
            <Skeleton variant="rectangular" width={25} height={25} sx={{ borderRadius: 1 }} />
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 5,
              marginBottom: 3,
            }}
          >
            <Chip
              icon={
                <Box
                  sx={{
                    width: 16,
                    height: 16,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: Chipstyle.backgroundColor,
                    borderRadius: "50%",
                  }}
                >
                  <FiberManualRecordIcon
                    fontSize="inherit"
                    sx={{ color: Chipstyle.color, }}
                  />
                </Box>
              }
              label={headerResponse?.severity}
              size="small"
              sx={{
                fontWeight: "bold",
                ...Chipstyle,
                borderRadius: 1,
              }}
            />
            <Tooltip
              title={
                headerResponse?.type === "Automated"
                  ? "This recommendation can be analysed automatically. No Manual intervention required."
                  : "This recommendation should be reviewed manually."
              }
              arrow
              slotProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#fff",
                    color: "#000",
                    boxShadow: 1,
                    fontSize: "0.775rem",
                  },
                },
                arrow: {
                  sx: {
                    color: "#fff",
                  },
                },
              }}
            >
              <Chip
                label={headerResponse?.type}
                sx={{
                  bgcolor: TypeChipColor(headerResponse?.type).bgcolor,
                  color: TypeChipColor(headerResponse?.type).color,
                  minHeight: 24,
                  borderRadius: "4px",
                  fontWeight: 600,
                  cursor: "pointer",
                  pointerEvents: "auto",
                  "&:hover": {
                    cursor: "pointer",
                  },
                  "& .MuiChip-label": {
                    cursor: "default",
                    pointerEvents: "auto",
                  },
                }}
                size="small"
              />
            </Tooltip>

            <Divider orientation="vertical" flexItem />
            <Typography
              sx={{ fontWeight: 600, fontSize: "14px", color: "#8787AE" }}
            >
              Tags:
            </Typography>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 5,
                cursor: "default",
              }}
            >
              {visibleTags.map((tag: string, index: number) => {
                const displayTag =
                  tag.length > 10
                    ? tag.charAt(0).toUpperCase() + tag.slice(1, 10) + "..."
                    : tag.charAt(0).toUpperCase() + tag.slice(1);
                return tag.length > 10 ? (
                  <Tooltip
                    key={index}
                    title={displayTag}
                    arrow
                    slotProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "#fff",
                          color: "#000",
                          boxShadow: 1,
                          fontSize: "0.775rem",
                        },
                      },
                      arrow: {
                        sx: {
                          color: "#fff",
                        },
                      },
                    }}
                  >
                    <span>{getStyledTag(displayTag, index)}</span>
                  </Tooltip>
                ) : (
                  getStyledTag(displayTag, index)
                );
              })}

              {hiddenTags.length > 0 && (
                <Tooltip
                  title={hiddenTags
                    .map((tag) => tag.charAt(0).toUpperCase() + tag.slice(1))
                    .join(", ")}
                  arrow
                  placement="top"
                  slotProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: "#fff",
                        color: "#000",
                        boxShadow: 1,
                        fontSize: "0.775rem",
                      },
                    },
                    arrow: {
                      sx: {
                        color: "#fff",
                      },
                    },
                  }}
                >
                  <div
                    style={{
                      border: "2px solid #BEBED1",
                      borderRadius: "5px",
                      width: 25,
                      height: 25,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: "bold",
                      fontSize: 13,
                      cursor: "default",
                    }}
                  >
                    +{hiddenTags.length}
                  </div>
                </Tooltip>
              )}
            </div>
            <div>
              <img
                src={getImage()}
                alt="edit"
                style={{ cursor: "pointer", width: "25px", marginLeft: 10 }}
                onClick={handleClick}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              />
              <Popover
                id={id}
                open={openPopover}
                anchorEl={anchorEl}
                onClose={handleClosePopover}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
                sx={{
                  "& .MuiPopover-paper": {
                    boxShadow: 1,
                    mt: 1,
                  },
                }}
              >
                {isCreateTagClicked ? (
                  <form onSubmit={formik.handleSubmit}>
                    <Box sx={{ bgcolor: "background.paper", p: 1 }}>
                      <Typography
                        variant="body2"
                        fontWeight="700"
                        sx={{ mb: 1 }}
                      ></Typography>
                      <TextField
                        variant="outlined"
                        sx={{ mb: 2 }}
                        placeholder="Create Tag"
                        id="create_tag"
                        name="create_tag"
                        required
                        value={formik.values.create_tag}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.create_tag &&
                          Boolean(formik.errors.create_tag)
                        }
                        helperText={
                          formik.touched.create_tag && formik.errors.create_tag
                        }
                      />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Button
                          variant="outlined"
                          sx={{ width: 90 }}
                          onClick={() => setIsCreateTagClicked(false)}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="contained"
                          sx={{ width: 90 }}
                          type="submit"
                          disabled={!formik.values.create_tag || isCreatingTag}
                        >
                          {isCreatingTag ? (
                            <CircularProgress size={20} color="inherit" />
                          ) : (
                            "Create"
                          )}
                        </Button>
                      </div>
                    </Box>
                  </form>
                ) : (
                  <Box sx={{ p: 1, bgcolor: "background.paper" }}>
                    <TextField
                      id="outlined-basic"
                      variant="outlined"
                      placeholder="Search"
                      sx={{ mb: 1, color: "#E9E9F8", backgroundClip: "#E9E9F8" }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Divider sx={{ color: "#D2D2F6" }} />
                    <div
                      style={{
                        display: "flex",
                        gap: 5,
                        marginTop: 10,
                        marginBottom: 10,
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={Plus_Blue_img}
                        alt=""
                        style={{ width: 30, cursor: "pointer" }}
                        onClick={() => setIsCreateTagClicked(true)}
                      />
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#3A2ADA",
                          fontSize: "16px",
                          fontWeight: 700,
                          cursor: "pointer",
                        }}
                        onClick={() => setIsCreateTagClicked(true)}
                      >
                        Create Tag
                      </Typography>
                    </div>
                    <Divider sx={{ color: "#D2D2F6" }} />
                    <div>
                      {/* User Tags - show first so newly created tags appear at top */}
                      <Box
                        display="flex"
                        flexDirection="column"
                        gap="0.5rem"
                        mb={isCreateTag?.default?.length ? 2 : 0}
                      >
                        {isCreateTag?.user && isCreateTag.user.length > 0 ? (
                          isCreateTag.user.map((tag: string, index: number) => (
                            <Tooltip
                              title={tag.length > 10 ? tag : ""}
                              arrow
                              slotProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor: "#fff",
                                    color: "#000",
                                    boxShadow: 1,
                                    fontSize: "0.875rem",
                                  },
                                },
                                arrow: {
                                  sx: {
                                    color: "#fff",
                                  },
                                },
                              }}
                            >
                              <Typography
                                key={`user-${index}`}
                                variant="body2"
                                sx={{
                                  fontWeight: 700,
                                  fontSize: "16px",
                                  color: "#6D738F",
                                  maxWidth: "150px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  cursor: tag.length > 10 ? "pointer" : "default",
                                }}
                              >
                                {tag}
                              </Typography>
                            </Tooltip>
                          ))
                        ) : (
                          <div></div>
                        )}
                      </Box>

                      {/* Default Tags - show after user tags */}
                      <Box display="flex" flexDirection="column" gap="0.5rem">
                        {isCreateTag?.default && isCreateTag.default.length > 0 ? (
                          isCreateTag.default.map((tag: string, index: number) => (
                            <Tooltip
                              title={tag.length > 10 ? tag : ""}
                              arrow
                              slotProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor: "#fff",
                                    color: "#000",
                                    boxShadow: 1,
                                    fontSize: "0.875rem",
                                  },
                                },
                                arrow: {
                                  sx: {
                                    color: "#fff",
                                  },
                                },
                              }}
                            >
                              <Typography
                                key={`default-${index}`}
                                variant="body2"
                                sx={{
                                  fontWeight: 700,
                                  fontSize: "16px",
                                  color: "#6D738F",
                                  maxWidth: "150px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  cursor: tag.length > 10 ? "pointer" : "default",
                                }}
                              >
                                {tag}
                              </Typography>
                            </Tooltip>
                          ))
                        ) : (
                          <div></div>
                        )}
                      </Box>
                    </div>
                  </Box>
                )}
              </Popover>
            </div>
          </div>
        )}
      </Box>
      <Box sx={{ flexGrow: 1, overflowY: "auto" }} className="scroll">
        {showLogOutput && logOutputRowData ? (
          (logOutputRowData?.vendor === "juniper" && selectedRow?.is_manual === true) ? (
            (() => {
              const juniperAssets = assetsData.filter(asset => asset.vendor === "juniper");
              const currentJuniperIndex = juniperAssets.findIndex(asset => asset.id === logOutputRowData?.id);

              // Safety check: if findIndex returns -1, default to 0
              const safeCurrentIndex = currentJuniperIndex >= 0 ? currentJuniperIndex : 0;

              console.log("Component: Asset", safeCurrentIndex + 1, "of", juniperAssets.length, "-", logOutputRowData?.hostname);

              return (
                // <LogoutputManual
                //   rowData={logOutputRowData}
                //   parameter_name_id={row?.id}
                //   onBack={() => setShowLogOutput(false)}
                //   module={module}
                //   assetsData={juniperAssets}
                //   currentAssetIndex={safeCurrentIndex}
                //   onNextAsset={handleNextAsset}
                //   onPreviousAsset={handlePreviousAsset}
                // />
                <Logoutput
                  rowData={logOutputRowData}
                  parameter_name_id={row?.id}
                  onBack={() => setShowLogOutput(false)}
                  module={module}
                  parameterType={row?.parameter_type}
                />
              );
            })()
          ) : (
            <Logoutput
              rowData={logOutputRowData}
              parameter_name_id={row?.id}
              onBack={() => setShowLogOutput(false)}
              module={module}
              parameterType={row?.parameter_type}
            />
          )
        ) : (
          <Box
            sx={{ position: "sticky", zIndex: 9, overflow: "auto" }}
            className="scroll"
          >
            {/* <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={(_event, newValue) => {
                  setValue(newValue);
                  dispatch(setTabSelected(newValue));
                }}
                aria-label="basic tabs example"
              >
                {["Assets", "Compliance", "Details"].map((label, index) => (
                  <Tab
                    key={index}
                    label={
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: "bold",
                          color: value === index ? "#3A2ADA" : "#8787AE",
                        }}
                      >
                        {label}
                      </Typography>
                    }
                    sx={{
                      minWidth: 100,
                      "&.Mui-selected": { color: "#3A2ADA" },
                      "&:not(.Mui-selected)": { color: "#8787AE" },
                      textTransform: "none",
                    }}
                  />
                ))}
              </Tabs>
            </Box> */}
            {/* Tab Panels */}
            {/* {value === 0 && (
              <AssetsFlyout
                id={row?.id}
                module={module}
                onDataFetched={setAssetsData} // 👈 store assets in parent

                onRowClick={(row: any) => {
                  setShowLogOutput(true);
                  setLogOutputRowData(row);
                }}
              />
            )} */}

            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={(_event, newValue) => {
                  setValue(newValue);
                  dispatch(setTabSelected(newValue));
                }}
                aria-label="basic tabs example"
              >
                {(() => {
                  const tabsList = [
                    { label: "Assets", index: 0 },
                    { label: "Compliance", index: 1 },
                    { label: "Details", index: 2 },
                  ];

                  let visibleTabs = tabsList;
                  const paramType = row?.parameter_type?.toLowerCase();
                  if (paramType === "template" || paramType === "custom") {
                    visibleTabs = visibleTabs.filter(tab => tab.label !== "Compliance");
                  }

                  return visibleTabs.map((tab) => (
                    <Tab
                      key={tab.index}
                      value={tab.index}
                      label={
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: "bold",
                            color: value === tab.index ? "#3A2ADA" : "#8787AE",
                          }}
                        >
                          {tab.label}
                        </Typography>
                      }
                      sx={{
                        minWidth: 100,
                        "&.Mui-selected": { color: "#3A2ADA" },
                        "&:not(.Mui-selected)": { color: "#8787AE" },
                        textTransform: "none",
                      }}
                    />
                  ));
                })()}
              </Tabs>
            </Box>
            {/* Tab Panels */}
            {/* Tab Panels */}
            {value === 0 && (
              <AssetsFlyout
                id={row?.id}
                module={module}
                parameterType={row?.parameter_type}
                onDataFetched={setAssetsData}
                onRowClick={(row: any) => {
                  setShowLogOutput(true);
                  setLogOutputRowData(row);
                }}
              />
            )}
            {value === 1 && !(row?.parameter_type?.toLowerCase() === "template" || row?.parameter_type?.toLowerCase() === "custom") && (
              <Compliance id={row?.id} module={module} />
            )}
            {value === 2 && (
              <DetailsFlyout
                Total_Resources={totalResources}
                id={row?.id}
                module={module}
                isTotal={true}
                parameterType={row?.parameter_type}
              />
            )}
          </Box>
        )}
      </Box>
    </Drawer>
  );
};

export default SecurityDetailsDrawer;
